import React, { useState } from 'react';
import './ImpressumModal.css';

function ImpressumModal() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
    <button className="impressum-button" onClick={() => setShowModal(true)}>Impressum</button>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Impressum</h2>
            <p>
              [Deine Firma]<br />
              [Straße & Hausnummer]<br />
              [PLZ & Ort]<br />
              Telefon: [Telefonnummer]<br />
              E-Mail: [E-Mail-Adresse]
            </p>
            <button  onClick={() => setShowModal(false)}>Schließen</button>
          </div>
        </div>
      )}
    </>
  );
}

export default ImpressumModal;
